import { Component, EventEmitter, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { HealthOrganizationSetupDomain } from "src/app/core/model/v2/practice/HealthOrganizationSetupDomain";
import { HealthSystemSetup } from "src/app/core/model/v2/practice/HealthSystemSetup";
import { UserSetup } from "src/app/core/model/v2/practitioner/UserSetup";
import { CommonService } from "src/app/core/services/v2/common.service";
import { PracticeService } from "src/app/core/services/v2/practice.service";
import { StaffService } from "src/app/core/services/v2/staff.service";
import { SideBarInitializeParameters } from "src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PracticeManagerFormComponent } from "../../profiles/practice-manager-form/practice-manager-form.component";
import { SetupService } from "../../setup.service";

@Component({
  selector: "app-setup-summary",
  templateUrl: "./setup-summary.component.html",
  styleUrls: ["./setup-summary.component.scss"],
})
export class SetupSummaryComponent implements OnInit {
  healthOrganizationSetup: HealthOrganizationSetupDomain = new HealthOrganizationSetupDomain();
  selectedHealthSystemsArray: any;
  selectedHealthSystem: any;
  selectedIds: [];
  physicians: UserSetup[];
  attorneys: UserSetup[];
  casemanagers: UserSetup[];
  statesCodes: CodeTable;
  assistants: UserSetup[];
  medicalProfessionalAvailableRoles: string[];
  careGivers: UserSetup[];
  APPs: UserSetup[];
  APPRoles: string[];
  licensedProfessionalAvailableRoles: string[];
  staffs: UserSetup[];
  staffRoles: string[];
  togglePracticeManagerSidebar = this.commonService.togglePatientProfileSidebar;
  showPracticeManagerSidebar: boolean = false;
  practiceManager: any;

  constructor(
    private practiceService: PracticeService,
    private setupService: SetupService,
    private staffService: StaffService,
    private loaderService: WindowLoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    let ids = this.route.snapshot.queryParamMap.get("idsArray");
    this.selectedIds = JSON.parse(ids);
    this.loadData();
    this.getSates();
  }

  private buildUsersList() {
    this.medicalProfessionalAvailableRoles = this.UserRolesPerCategory(
      "Medical Professional"
    );
    this.licensedProfessionalAvailableRoles = this.UserRolesPerCategory(
      "Licensed Professional"
    );
    this.APPRoles = this.UserRolesPerCategory("APP");
    this.staffRoles = this.UserRolesPerCategory("Staff");
    this.physicians = this.selectedHealthSystem.users.filter(
      (x) => x.role == "Physician"
    );
    this.attorneys = this.selectedHealthSystem.users.filter(
      (x) => x.role == "Attorney"
    );
    this.casemanagers = this.selectedHealthSystem.users.filter(
      (x) => x.role == "CaseManager"
    );

    this.assistants = this.selectedHealthSystem.users.filter(
      (x) => this.medicalProfessionalAvailableRoles.indexOf(x.role) >= 0
    );
    this.careGivers = this.selectedHealthSystem.users.filter(
      (x) => this.licensedProfessionalAvailableRoles.indexOf(x.role) >= 0
    );
    this.APPs = this.selectedHealthSystem.users.filter(
      (x) => this.APPRoles.indexOf(x.role) >= 0
    );
    this.staffs = this.selectedHealthSystem.users.filter(
      (x) => this.staffRoles.indexOf(x.role) >= 0
    );
  }

  private UserRolesPerCategory(desiredCategory: string): string[] {
    return this.healthOrganizationSetup.userRoles
      .filter((userRole) => userRole.category == desiredCategory)
      .map((userRole) => userRole.role);
  }

  selectHS(hs: HealthSystemSetup) {
    this.selectedHealthSystem = hs;
    this.buildUsersList();
  }

  loadData(): void {
    if (this.selectedHealthSystem) {
      var lastSelectedHsid = this.selectedHealthSystem.id;
    }
    this.loaderService.show();
    this.practiceService.getHealthOrganizationDetailsByLoggedUser().subscribe(
      (data) => {
        
        this.healthOrganizationSetup = data;
        this.selectedHealthSystemsArray =
          this.healthOrganizationSetup.healthSystems.filter((hs) => {
            return this.selectedIds.find((id) => {
              return hs.id === id;
            });
          });
        this.selectedHealthSystem = this.selectedHealthSystemsArray[0];

        this.buildUsersList();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  goBack(): void {
    this.router.navigate(["/physician/profile/setup"]);
  }

  goToCheckout(): void {
    if (
      !this.healthOrganizationSetup.healthSystems.some((hs) =>
        hs.users.some((user) => user.isGlobalAdministrator)
      )
    ) {
      this._snackBar.open(
        "It is Required to select at least one Global Administrator!",
        "Ok"
      );
    } else {
      this.loaderService.show();
      this.practiceService.isReadyToCheckout().subscribe(
        (result) => {
          this.loaderService.hide();
          if (result.resultStatus.isSuccess) {
            this.router.navigate(["/physician/profile/setupCheckout"]);
          } else {
            this._snackBar.open(result.resultStatus.message, "Ok");
          }
        },
        (error) => this.loaderService.hide()
      );
    }
  }

  // editPractitioner(event: UserSetup): void {
  //   this.setupService.editPractitioner$.next(event);
  // }

  deletePractitioner(event: UserSetup): void {
    this.loaderService.show();
    this.practiceService.deletePractitioner(event.practitioner.id).subscribe(
      (_) => {
        this.loadData();
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }
  deleteAttorney(event: UserSetup): void {
    this.loaderService.show();
    this.practiceService.deletePractitioner(event.practitioner.id).subscribe(
      (_) => {
        this.loadData();
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  addPhysician(): void {
    this.setupService.physicianIsOpened = true;
  }
  addAttorney(): void {
    this.setupService.attorneyIsOpened = true;
  }
  addCaseManager(): void {
    this.setupService.caseManagerIsOpened = true;
  }
  editPhysician(event: UserSetup): void {
    this.setupService.editPhysician$.next(event);
    //this.editPractitioner(event);
    this.setupService.physicianIsOpened = true;
  }
  editAttorney(event: UserSetup): void {
    this.setupService.editAttorney$.next(event);
    this.setupService.attorneyIsOpened = true;
  }
  editCaseManager(event: UserSetup): void {
    this.setupService.editCaseManager$.next(event);
    this.setupService.caseManagerIsOpened = true;
  }
  addAPP(): void {
    this.setupService.APPIsOpened = true;
  }

  editAPP(event: UserSetup): void {
    this.setupService.editAPP$.next(event);
    //this.editPractitioner(event);
    this.setupService.APPIsOpened = true;
  }

  addAssistant(): void {
    this.setupService.assistantIsOpened = true;
  }

  editAssistant(event: UserSetup): void {
    this.setupService.editPhysicianAssistant$.next(event);
    //this.editPractitioner(event);
    this.setupService.assistantIsOpened = true;
  }

  addCareGiver(): void {
    this.setupService.careGiverIsOpened = true;
  }

  editCareGiver(event: UserSetup): void {
    this.setupService.editCareGiver$.next(event);
    this.setupService.careGiverIsOpened = true;
  }

  addStaff(): void {
    this.setupService.staffIsOpened = true;
  }

  editStaff(event: UserSetup): void {
    this.setupService.editStaff$.next(event);
    this.setupService.staffIsOpened = true;
  }

  deleteStaff(event: UserSetup): void {
    this.loaderService.show();
    this.staffService.deleteStaff(event.id).subscribe(
      (_) => {
        this.loadData();
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  deleteCaseManager() {}

  togglePracticeManagerEditSidebar() {
    this.showPracticeManagerSidebar = !this.showPracticeManagerSidebar;
    this.togglePracticeManagerSidebar = !this.togglePracticeManagerSidebar;
    if (this.showPracticeManagerSidebar) {
      this.practiceManager = {
        practiceManagerData: this.selectedHealthSystem.practiceManagerUser
          ? this.selectedHealthSystem.practiceManagerUser
          : "",
        hsId: this.selectedHealthSystem.id,
      };
    } else if (!this.togglePracticeManagerSidebar) {
      this.loadData();
    }
  }

  getSates() {
    this.commonService.GetItemsByCodeNamesWithoutCache(["STATE"]).subscribe(
      (codeTables) => {
        this.statesCodes = codeTables.codeTable[0];
      },
      (error) => console.log(error)
    );
  }
}
